module.exports = __webpack_public_path__ + "static/basePath-1419948d3bd916baea4f35d8acaf4dbe.png";